


















































































































import moment from 'moment';
import 'moment/locale/zh-cn';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { DataprocessDto, JobCronInfo } from '@/services/dataprocess';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
@Component
export default class DataprocessFlinksql6 extends mixins(DictMixin) {
  @PropSync('jobConfig') syncJobConfig!: JobCronInfo;
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  
  headStyle = 'fontWeight: 600;';
  time = moment('00:00:00', 'HH:mm:ss');
  date = moment();
  
  type = 0;
  weekday = '1';
  day = 1;
  season = 0;

  dataDurationList = ['T','T+1','T+2','T+3'];

  created() {
    this.onSyncJobConfigChange();
  }

  @Watch('syncJobConfig')
  onSyncJobConfigChange() {
    if (this.syncJobConfig.runDateStr ) {
      this.date = moment(this.syncJobConfig.runDateStr, 'YYYY-MM-DD');
    }
    if (this.syncJobConfig.runTimeStr) {
      this.time = moment(this.syncJobConfig.runTimeStr, 'HH:mm:ss');
    } else {
      this.time = moment('00:00:00', 'HH:mm:ss');
    }
    this.type = this.syncJobConfig.rate || 0;
    this.day = this.syncJobConfig.day || 1;
    this.weekday = this.syncJobConfig.weekday || '1';
    this.season = this.syncJobConfig.season || 0;
    this.syncJobConfig.failRetryCount = this.syncJobConfig.failRetryCount ?? 3;
    this.syncJobConfig.failTimeout = this.syncJobConfig.failTimeout ?? 30;
 
    this.changeCron();
  }

  changeCron() {
    let year = moment(this.date).format('Y');
    let month = moment(this.date).format('M');
    let day = moment(this.date).format('D');
    let hour = moment(this.time).hour();
    let minute = moment(this.time).minute();
    let second = moment(this.time).second();
    let cron = '';
    if (this.syncJobConfig.triggerMode == 1) {
      cron = `${second} ${minute} ${hour} ${day} ${month} ? ${year}`;
    }
    if (this.syncJobConfig.triggerMode == 2) {
      // 每天
      this.type == 0 && (cron = `${second} ${minute} ${hour} * * ?`);
      // 每小时
      this.type == 1 && (cron = `${second} ${minute} * * * ?`);
      // 每周
      this.type == 2 && (cron = `${second} ${minute} ${hour} * * ${this.weekday} ?`);
      // 每月
      this.type == 3 && (cron = `${second} ${minute} ${hour} ${this.day} * ?`);
      // 每季
      if (this.type == 4) {
        let month = '1,4,7,10';
        let d: any = '1';
        if (this.season === 1) {
          month = '3,6,9,12';
          d = 'L';
        }
        this.season === 2 && (d = this.day);
        cron = `${second} ${minute} ${hour} ${d} ${month} ?`;
      }
      // 每年
      this.type == 5 && (cron = `${second} ${minute} ${hour} ${day} ${month} ?`);
    }

    this.syncJobConfig.cronExpression = cron;
    this.syncJobConfig.rate = this.type;
    this.syncJobConfig.day = this.day;
    this.syncJobConfig.weekday = this.weekday;
    this.syncJobConfig.season = this.season;
    this.syncJobConfig.runDateStr = moment(this.date).format('YYYY-MM-DD');
    this.syncJobConfig.runTimeStr = moment(this.time).format('HH:mm:ss');
  }
}
